import script from "./PersonTypeSelection.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonTypeSelection.vue?vue&type=script&setup=true&lang=js"

import "./PersonTypeSelection.vue?vue&type=style&index=0&id=5a9efdb0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9efdb0"]])

export default __exports__